import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import '@/App.css';

import { I18nProvider } from '@/lib/i18n';
import Navbar from '@/components/Navbar';
import GrainOverlay from '@/components/GrainOverlay';
import CustomCursor from '@/components/CustomCursor';
import Home from '@/pages/Home';
import Privacy from '@/pages/Privacy';
import AboutPage from '@/pages/AboutPage';

// Redirect any visitor landing on the default Emergent deploy URL
// (e.g. sacred-moments-34.emergent.host) to the primary branded domain.
// IMPORTANT: We must NOT redirect from *.preview.emergentagent.com — that is
// the internal preview environment used for iterating before deploy.
if (typeof window !== 'undefined') {
  const host = window.location.hostname;
  const isDefaultDeploy = host.endsWith('.emergent.host');
  if (isDefaultDeploy) {
    window.location.replace(
      'https://rubedo.info' + window.location.pathname + window.location.search + window.location.hash
    );
  }
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <I18nProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <CustomCursor />
          <GrainOverlay />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
          <Toaster
            position="bottom-center"
            theme="dark"
            toastOptions={{
              className: 'font-sans',
              style: {
                background: '#0F0A0A',
                border: '1px solid rgba(243,216,199,0.2)',
                color: '#F3D8C7',
                fontFamily: 'Manrope, sans-serif',
                letterSpacing: '0.05em',
              },
            }}
          />
        </BrowserRouter>
      </div>
    </I18nProvider>
  );
}

export default App;
